<script lang="ts" setup>
import RecentReports from '@/components/RecentReports/RecentReports.vue'
import InvestorHero from '@/domains/investor/components/Hero/Hero.vue'
import { useReports } from '@/domains/investor/reports/composables/useReports.composable'
import { EMainCategories } from '@/domains/investor/const/MainCategories.enum'
import TradingViewChart from '@/domains/investor/components/TradingViewChart/TradingViewChart.vue'
import CompanyDescription from '@/domains/investor/components/CompanyDescription/CompanyDescription.vue'

definePageMeta({
  layout: 'investor',
})

const { t, locale } = useI18n()

useHead(() => ({
  title: t('pageTitles.investorMain.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.investorMain.meta'),
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: t(`pageTitles.investorMain.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.investorMain.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.investorMain.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.investorMain.canonical.pl'),
    },
  ],
}))

const { reports } = await useReports({ mainCategory: EMainCategories.REPORT }, 1, 3, 'investor-recent-reports')
</script>

<template>
  <div class="investor-main-page">
    <InvestorHero
      class="investor-main-page__hero"
      :title="$t('investor.mainPage.title')"
      :lead="$t('investor.mainPage.description')"
      :first-button="{ text: $t('investor.mainPage.firstButton'), to: `#${$t('investor.mainPage.company')}` }"
      image="/images/investor/hero/main.png"
    />

    <div :id="$t('investor.mainPage.company')">
      <CompanyDescription />
    </div>

    <TradingViewChart
      :show-title="false"
    />

    <RecentReports :reports="reports" />
  </div>
</template>
